import React, { useState } from 'react'
import { PropTypes } from 'prop-types'

import SanityImage from 'gatsby-plugin-sanity-image'
import PortableText from '../../portableText'
import { FlipCardBack, FlipCardFront, MarketectureContainer, MCard, MFlip, MSection } from './Marketecture.styles'

const BackFlips = ({ portableTextBlock }) => <PortableText blocks={portableTextBlock} />

const MarketectureCard = ({ title, illustration, flipClass, text }) => {
	const { image } = illustration

	return (
		<MCard>
			{flipClass === 'bottomFlip' ? (
				<>
					<h3>
						<strong>{title}</strong>
					</h3>
					<PortableText blocks={text} />
					<SanityImage asset={illustration.image.asset} alt={illustration.image.alt} {...illustration} />
				</>
			) : (
				<>
					{image && (
						<SanityImage asset={illustration.image.asset} alt={illustration.image.alt} {...illustration} />
					)}
					<p>{title}</p>
				</>
			)}
		</MCard>
	)
}

const MarketectureFlip = ({ front, title, back, flipClass }) => {
	const [flipped, setFlipped] = useState(true)

	function flipIt() {
		if (flipped) {
			setFlipped(false)
		} else {
			setFlipped(true)
		}
	}

	return (
		<MFlip onClick={flipIt} className={flipClass}>
			{flipped ? (
				<FlipCardFront>
					{title && (
						<>
							<div className={`titleContainer ${flipClass || ''}`}>
								<PortableText blocks={title} />
							</div>
						</>
					)}

					<div className={`cardInfo ${flipClass || ''}`}>
						{front.map((cardInfo) => (
							<MarketectureCard key={cardInfo._key} flipClass={flipClass} {...cardInfo} />
						))}
					</div>
				</FlipCardFront>
			) : (
				<FlipCardBack>
					<>
						<div className={`titleContainer ${flipClass || ''}`}>
							<BackFlips {...back} />
						</div>
					</>
				</FlipCardBack>
			)}
		</MFlip>
	)
}

const MarketectureSection = ({ title, rows, sectionClass }) => (
	<MSection sectionRow={sectionClass}>
		<div className="sectionTitle">
			<h3>{title}</h3>
		</div>
		<div className="sectionRows">
			{rows.map((row) => (
				<MarketectureFlip key={row._key} {...row} />
			))}
		</div>
	</MSection>
)

export default function Marketecture({ rows }) {
	return (
		<MarketectureContainer>
			{rows.map((row) => (
				<MarketectureSection key={row._key} {...row} />
			))}
		</MarketectureContainer>
	)
}

Marketecture.propTypes = {
	rows: PropTypes.array,
}

MarketectureSection.propTypes = {
	title: PropTypes.string,
	sectionClass: PropTypes.string,
	rows: PropTypes.array,
}

MarketectureFlip.propTypes = {
	title: PropTypes.array,
	front: PropTypes.array,
	back: PropTypes.object,
	flipClass: PropTypes.string,
}

MarketectureCard.propTypes = {
	title: PropTypes.string,
	flipClass: PropTypes.string,
	illustration: PropTypes.object,
	text: PropTypes.array,
}

BackFlips.propTypes = {
	portableTextBlock: PropTypes.array,
}
